import { render, staticRenderFns } from "./LayoutWdmaHistList.vue?vue&type=template&id=03c031e9"
import script from "./LayoutWdmaHistList.vue?vue&type=script&lang=js"
export * from "./LayoutWdmaHistList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports